import { render, staticRenderFns } from "./Kraken-button.vue?vue&type=template&id=aa69c136&scoped=true&"
import script from "./Kraken-button.vue?vue&type=script&lang=ts&"
export * from "./Kraken-button.vue?vue&type=script&lang=ts&"
import style0 from "./Kraken-button.vue?vue&type=style&index=0&id=aa69c136&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa69c136",
  null
  
)

export default component.exports